export interface FieldSvgPathD7  {
  und: [{
    value: string | Node
  }];
}

export type FieldSvgPathD9  = {
  value: string | Node
}[];

export interface FieldSvgLabel {
  text: string;
  x: number;
  y: number;
}

export class TaxonomyTerm {
  tid: number = undefined;
  vid: number = undefined;
  name: string = undefined;
  description: string = undefined;
  vocabulary_machine_name: string = undefined;
  field_svg_path: FieldSvgPathD7 | FieldSvgPathD9 = undefined;
  path: string = undefined;
  label: FieldSvgLabel = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }
}
